import { render, staticRenderFns } from "./BankAccountsTab.vue?vue&type=template&id=58c73c37"
import script from "./BankAccountsTab.vue?vue&type=script&lang=js"
export * from "./BankAccountsTab.vue?vue&type=script&lang=js"
import style0 from "./BankAccountsTab.vue?vue&type=style&index=0&id=58c73c37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports